package ui.screens.section.wisheslist

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.sp
import ui.theme.Domine
import ui.theme.EmojiFont
import ui.theme.txtColor

private val emojiRegex = Regex("\\p{So}|\\p{Cn}")

@Composable
fun EmojiText(text: String) {

    val parsed = remember(text) {
        buildList {
            var lastIndex = 0
            emojiRegex.findAll(text).forEach { match ->
                if (match.range.first > lastIndex) {
                    add(text.substring(lastIndex, match.range.first))
                }
                add(match.value)
                lastIndex = match.range.last + 1
            }
            if (lastIndex < text.length) {
                add(text.substring(lastIndex))
            }
        }
    }

    val baseStyle = MaterialTheme.typography.bodySmall
    val annotated = buildAnnotatedString {
        parsed.forEach { part ->
            withStyle(
                baseStyle.toSpanStyle().copy(
                    fontFamily = if (emojiRegex.matches(part))
                        EmojiFont
                    else
                        Domine,
                    color = txtColor,
                    fontSize = 14.sp
                )
            ) {
                append(part)
            }
        }
    }

    Text(annotated)
}
